var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "title": "근로계약 출근QR",
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "topBtn"
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('attendance-code-form', _vm._g({
    on: {
      "input": _vm.updateItem
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-100px min-w-lg-140px",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("생성하기")])];
      }
    }])
  }, {
    search: _vm.search
  }))], 1)], 1), _c('template', {
    slot: "contents"
  }, [_vm.codes.length ? [_c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined rounded-0",
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref2) {
          var value = _ref2.value,
            item = _ref2.item;
          return [_c('div', {
            key: header.value
          }, [_vm._v(_vm._s(header.formatter(value, item)))])];
        }
      };
    }), {
      key: `item.uses`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-switch', _vm._b({
          on: {
            "change": function (uses) {
              return _vm.update({
                _id: item._id,
                uses
              });
            }
          },
          model: {
            value: item.uses,
            callback: function ($$v) {
              _vm.$set(item, "uses", $$v);
            },
            expression: "item.uses"
          }
        }, 'v-switch', Object.assign({}, _vm.attrs_switch), false))];
      }
    }, {
      key: `item.view`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('attendance-code-view', _vm._b({
          on: {
            "input": _vm.updateItem
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref5) {
              var attrs = _ref5.attrs,
                on = _ref5.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "block": "",
                  "color": "primary"
                }
              }, 'v-btn', attrs, false), on), [_vm._v(" 확인하기 ")])];
            }
          }], null, true)
        }, 'attendance-code-view', {
          value: item
        }, false))];
      }
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers,
    mobileBreakPoint: _vm.$vuetify.breakpoint.thresholds.sm
  }, false)), _c('v-pagination', {
    staticClass: "my-16",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })] : [_c('v-layout', {
    staticClass: "w-100 h-100 grey-f7 rounded-lg pa-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text--lg line-height-15 text-center mb-12 mb-lg-32"
  }, [_vm._v(" 안녕하세요, 담당자님. "), _c('br'), _vm._v(" 출근 QR코드가 없습니다. ")])])], _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "primary",
      "indeterminate": ""
    }
  })], 1)], 1)], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }